module.exports = __webpack_public_path__ + "static/img/china-unicom.60c4dbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/china-unicom.png
// module id = N3w3
// module chunks = 1 2